import { withDevtools, withGlitchTracking } from '@angular-architects/ngrx-toolkit';
import {
  INITIAL_OFFSHORE_REPORT_STATE,
  OFFSHORE_REPORT_STORE_ID,
  OffshoreReportState,
} from '@navstation-portal/reporting/data-model/offshore-report';
import { signalStore, withState } from '@ngrx/signals';
import { withOffshoreReportComputed } from './with-offshore-report-computed';
import { withOffshoreReportEffects } from './with-offshore-report-effects';
import { withOffshoreReportReducer } from './with-offshore-report-reducer';

export const OffshoreReportStore = signalStore(
  { providedIn: 'root' },
  withDevtools(OFFSHORE_REPORT_STORE_ID, withGlitchTracking()),
  withState<OffshoreReportState>(INITIAL_OFFSHORE_REPORT_STATE),
  withOffshoreReportEffects(),
  withOffshoreReportReducer(),
  withOffshoreReportComputed()
);
